// extracted by mini-css-extract-plugin
export var blockassetLogo = "BlockassetLogo_blockassetLogo__TjVsX";
export var header = "BlockassetLogo_header__hoSzI";
export var textBlockasset = "BlockassetLogo_textBlockasset__Gxoei";
export var footer = "BlockassetLogo_footer__8e5yb";
export var rotate = "BlockassetLogo_rotate__-3BZe";
export var dotty = "BlockassetLogo_dotty__DrNET";